import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { ROUTE } from '../config'
import Icon from './Icon'

import '../styles/VehicleYearSelector.scss'

export default class VehicleYearSelector extends Component {
  static propTypes = {
    currentYear: PropTypes.string.isRequired,
    years: PropTypes.array.isRequired,
    onSelected: PropTypes.func.isRequired,
    slider: PropTypes.bool,
    label: PropTypes.string,
    currentBrand: PropTypes.string,
  }

  state = {
    canGoPrev: false,
    canGoNext: false,
  }

  trackRef = null

  onYearBtnClick(e) {
    const clickedYear = e.target.dataset.year
    if (this.props.currentYear !== clickedYear) {
      this.props.onSelected(clickedYear)
    }
  }

  updateNavState = () => {
    const track = this.trackRef
    if (!track) {
      return
    }

    const maxScrollLeft = track.scrollWidth - track.clientWidth
    const canScroll = maxScrollLeft > 1

    this.setState({
      canGoPrev: canScroll && track.scrollLeft > 1,
      canGoNext: canScroll && track.scrollLeft < maxScrollLeft - 1,
    })
  }

  scrollByPage = (direction) => {
    const track = this.trackRef
    if (!track) {
      return
    }

    const amount = Math.max(track.clientWidth * 0.75, 120)
    track.scrollLeft += direction === 'next' ? amount : -amount
    this.updateNavState()
  }

  scrollToCurrentYear = () => {
    const track = this.trackRef
    const { currentYear } = this.props
    if (!track || !currentYear) {
      this.updateNavState()
      return
    }

    const active = track.querySelector('a.current')
    if (active) {
      const target = active.offsetLeft - track.clientWidth / 2 + active.offsetWidth / 2
      track.scrollLeft = Math.max(0, target)
    }

    this.updateNavState()
  }

  handlePrev = () => this.scrollByPage('prev')

  handleNext = () => this.scrollByPage('next')

  componentDidMount() {
    this.scrollToCurrentYear()
    window.addEventListener('resize', this.updateNavState)
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.currentYear !== prevProps.currentYear ||
      this.props.years !== prevProps.years
    ) {
      setTimeout(this.scrollToCurrentYear)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateNavState)
  }

  renderYearButtons() {
    const { currentYear, years } = this.props
    const buttons = []

    for (let i = 0; i < years.length; i++) {
      const isCurrent = years[i] === currentYear
      buttons.push(
        <div className={classNames('wrapper', { 'wrapper--current': isCurrent })} key={i}>
          <Link
            to={`${ROUTE.VEHICLES}/${years[i]}/`}
            {...(isCurrent ? { className: 'current' } : {})}
            data-year={years[i]}
            onClick={this.onYearBtnClick.bind(this)}
          >
            {years[i]}
          </Link>
        </div>,
      )
    }

    return buttons
  }

  render() {
    const { label } = this.props
    const { canGoPrev, canGoNext } = this.state
    const buttons = this.renderYearButtons()

    return (
      <div
        className={classNames('VehicleYearSelector', 'VehicleYearSelector--scrollable', {
          'VehicleYearSelector--has-prev': canGoPrev,
          'VehicleYearSelector--has-next': canGoNext,
        })}
      >
        {!!label && <label className='VehicleYearSelector__label'>{label}</label>}
        {canGoPrev && (
          <button
            type='button'
            className='VehicleYearSelector__nav VehicleYearSelector__nav--prev'
            onClick={this.handlePrev}
            aria-label='Previous years'
          >
            <Icon type='arrow-left' />
          </button>
        )}
        <div
          className='VehicleYearSelector__track'
          ref={(el) => {
            this.trackRef = el
          }}
          onScroll={this.updateNavState}
        >
          {buttons}
        </div>
        {canGoNext && (
          <button
            type='button'
            className='VehicleYearSelector__nav VehicleYearSelector__nav--next'
            onClick={this.handleNext}
            aria-label='Next years'
          >
            <Icon type='arrow-left' />
          </button>
        )}
      </div>
    )
  }
}
